import React, { useState } from "react";
import { PagamentoCartaoStyle } from "./style";
import { useEffect } from "react";
import CheckoutTransparenteService from "../../services/CheckoutTransparenteService";

export default function PagamentoCartao({ isDisabled, canPay, onSelectCard, onProcessarCartao }) {
  const [selectedCard, setSelectedCard] = useState(null);
  const [addCard, setAddCard] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [cardNumberInput, setCardNumberInput] = useState("");
  const [holderInput, setHolderInput] = useState("");
  const [apelido, setApelido] = useState("");
  const [expirationInput, setExpirationInput] = useState("");
  const [cvvInput, setCvvInput] = useState("");
  const [saveCard, setSaveCard] = useState(false);
  const [brand, setBrand] = useState("");

  const handleDelete = (uuid) => {
    checkoutTransparenteService.DeleteCard(uuid, (err) => {
      if (err) {
        return;
      }
      setCards((prev) => prev.filter((c) => c.uuid !== uuid));
    });
  };

  const [cards, setCards] = useState([]);
  const checkoutTransparenteService = new CheckoutTransparenteService();

  useEffect(() => {
    checkoutTransparenteService.ObterCards((err, data) => {
      if (err) {
        console.error("Erro ao obter cartões:", err);
        return;
      }

      const adaptedCards = data.map((c, index) => ({
        uuid: c.uuid,
        token: c.uuid,
        brand: c.brand,
        cardNumber: c.cardNumber,
        holder: c.holder || "—",
        saveCard: true,
        isSavedCard: true,
        cardName: c.cardName,
      }));

      setCards(adaptedCards);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (cards.length === 0) {
      setAddCard(true);
    } else {
      setAddCard(false);
    }
  }, [cards]);

  const handleUseCreditCard = () => {
    if (onSelectCard) {
      const card = cards.find((c) => c.uuid === selectedCard) || null;
      if (card) {
        onSelectCard({
          ...card,
          isSavedCard: true,
        });
      }
    }
    setAddCard(false);
  };

  const [formError, setFormError] = useState(null);

  const submitPayCreditCard = async () => {
    if (isProcessing) return;
    setIsProcessing(true);

    if (
      !cardNumberInput.trim() ||
      !holderInput.trim() ||
      !expirationInput.trim() ||
      !cvvInput.trim()
    ) {
      setFormError("Preencha todos os campos obrigatórios do cartão.");
      setIsProcessing(false);
      return;
    }
    const newCard = {
      cardNumber: cardNumberInput,
      holder: holderInput,
      expirationDate: expirationInput,
      securityCode: cvvInput,
      brand: brand || "DESCONHECIDA",
      saveCard: saveCard,
      cardName: apelido,
    };

    try {
      onSelectCard?.(newCard);
      onProcessarCartao?.(newCard);
    } finally {
      setIsProcessing(false);
    }
  };

  const listCards = () => {
    if (!addCard) {
      return (
        <div className="pagamento-cartao">
          <h2 className="titulo">Escolha o cartão de crédito</h2>

          {cards.map((card) => (
            <div
              key={card.uuid}
              className={`card-item ${selectedCard === card.uuid ? "selected" : ""}`}
              onChange={() => setSelectedCard(selectedCard === card.uuid ? null : card.uuid)}
            >
              <div className="card-left">
                <input
                  type="checkbox"
                  className="payment-checkbox"
                  checked={selectedCard === card.uuid}
                  onChange={() => setSelectedCard(selectedCard === card.uuid ? null : card.uuid)}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                  }}
                >
                  {card.cardName ? <span style={{ fontWeight: "bold" }}>{card.cardName}</span> : ""}
                  <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                    <span className="card-icon">
                      <ion-icon name="card-outline" style={{ fontSize: "22px" }}></ion-icon>
                    </span>
                    <span className="card-name">
                      {card.brand} {card.cardNumber}
                    </span>
                  </div>
                </div>
              </div>
              <div className="card-right">
                <span
                  className="delete-btn"
                  onClick={() => {
                    handleDelete(card.uuid);
                  }}
                >
                  <ion-icon name="trash-outline"></ion-icon>
                </span>
              </div>
            </div>
          ))}

          <div className="add-card" onClick={() => setAddCard(true)}>
            <ion-icon name="add-outline" style={{ fontSize: "22px" }}></ion-icon>
            <span>Cadastrar novo cartão</span>
          </div>
          <button
            className="back-btn"
            onClick={handleUseCreditCard}
            disabled={!selectedCard || isProcessing}
          >
            USAR
          </button>
        </div>
      );
    }
  };

  const cardForm = () => {
    if (addCard) {
      return (
        <>
          <div className="credit-card-form">
            <input
              type="text"
              placeholder="Número do cartão"
              className="input"
              value={cardNumberInput}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                setCardNumberInput(value);

                if (value.length >= 6) {
                  const bin = value.substring(0, 6);
                  checkoutTransparenteService.ObterBIN({ bin }, (err, data) => {
                    if (err) {
                      console.error("Erro ao obter BIN:", err);
                      setBrand("");
                      return;
                    }
                    setBrand(data.brand || "");
                  });
                } else {
                  setBrand("");
                }
              }}
              required
            />

            <input
              type="text"
              placeholder="Nome do titular do cartão"
              className="input"
              value={holderInput}
              onChange={(e) => setHolderInput(e.target.value)}
              required
            />

            <div className="row">
              <input
                type="text"
                placeholder="MM/AA"
                className="input half"
                value={expirationInput}
                maxLength={5}
                onChange={(e) => {
                  let value = e.target.value.replace(/\D/g, "");
                  if (value.length >= 3) {
                    value = value.slice(0, 2) + "/" + value.slice(2, 4);
                  }
                  setExpirationInput(value);
                }}
                required
              />

              <input
                type="text"
                placeholder="Código de segurança"
                className="input half"
                value={cvvInput}
                maxLength={3}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 3);
                  setCvvInput(value);
                }}
                required
              />
            </div>

            <input
              type="text"
              placeholder="Apelido do cartão (opcional)"
              className="input"
              value={apelido}
              onChange={(e) => setApelido(e.target.value)}
            />

            <div className="save-card">
              <span>Salvar cartão</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={saveCard}
                  onChange={(e) => setSaveCard(e.target.checked)}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div
              className={`use-other-card ${isProcessing ? "disabled-link" : ""}`}
              onClick={(e) => {
                if (isProcessing) {
                  e.preventDefault();
                  return;
                }
                setAddCard(false);
              }}
            >
              Usar cartão salvo
            </div>
          </div>
          <div>
            {formError && <p className="error-message">{formError}</p>}

            <button
              className="pix-button"
              onClick={submitPayCreditCard}
              disabled={isProcessing || isDisabled || canPay}
            >
              PAGAR AGORA
            </button>
          </div>
        </>
      );
    }
  };

  return (
    <PagamentoCartaoStyle>
      {listCards()}
      {cardForm()}
    </PagamentoCartaoStyle>
  );
}
